import React from 'react';
import { autobind } from 'core-decorators';
import List from 'src/componentes/list/tree';
import ListColumn from 'src/componentes/list/list-column';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import ContentManager from 'src/componentes/content-manager';
import Confirm from 'src/componentes/message-box/confirm';
import http from 'src/services/httpService';
import Button from 'src/componentes/button';
import { UncontrolledTooltip } from 'reactstrap';
import { capitalizeFirstLetter } from 'src/utils/string';
import errorHandler from 'src/utils/errorHandler';
import { TIPO_INTERACAO_SOPHIE } from 'src/utils/constants';
import { SophieIcon } from 'src/componentes/icons';
import LucideIcon from 'src/componentes/lucide-icon';

const CausasRiscoEdit = React.lazy(() => import('./edit'));
const CausaControleEdit = React.lazy(() =>
  import('../../components/CausaControleEdit')
);
const ValidacaoRestricao = React.lazy(() =>
  import('src/paginas/item/validacao-restricao')
);
const AssistenteVirtual = React.lazy(() =>
  import('src/components/IA/ChatGPT/AssistenteVirtual')
);

@autobind
class CausasRiscoList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      saved: -1,
      savedAfterRemove: -1,
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.refreshAfterRemove !== this.props.refreshAfterRemove) {
      this.setState({ saved: this.state.saved + 1 });
    }
  }

  renderDescricao(item, callback, configuracao) {
    if (!item.descricao || this.props.disabled) {
      return;
    }

    const causas = this.props.model || [];
    const someCauseHasChildren = causas.some(
      (causa) =>
        causa.hasChildren || (causa.children && causa.children.length > 0)
    );

    return (
      <div id={'itemId' + item.id} className="pull-right">
        {item.controle ? (
          <Button
            id="deletePicture"
            className="pull-right"
            onClick={this.handleDesvincularConfirmClick.bind(
              this,
              item,
              callback
            )}
            style={{ minWidth: '36px', minHeight: '36px' }}
            color={'danger'}
          >
            <LucideIcon color="#fff" icon="Trash2" size={15} />
          </Button>
        ) : (
          <a
            className="justify-content-end"
            tabIndex="-1"
            onClick={this.handleDescricaoClick.bind(this, item, callback)}
            style={{
              cursor: 'pointer',
              color:
                configuracao.associacaoControleCausaConsequenciaObrigatoria &&
                !someCauseHasChildren
                  ? '#e51c23'
                  : '#1d7789',
            }}
          >
            {this.props.intl.formatMessage(
              { id: 'vincularControle' },
              { pontodecontrole: this.props.resources.pontodecontrole }
            )}
            {configuracao.associacaoControleCausaConsequenciaObrigatoria &&
            !someCauseHasChildren
              ? ' *'
              : ''}
          </a>
        )}
      </div>
    );
  }

  handleDescricaoClick(item) {
    ContentManager.addContent(
      <CausaControleEdit
        defaultActiveKey={0}
        handleClose={this.handleCloseEdit}
        item={item}
      />
    );
  }

  handleDesvincularClick(item) {
    ContentManager.addContent(
      <ValidacaoRestricao
        url="/RiscoCausaControle/ValidarRestricoes"
        item={item}
        urlExclusao={'RiscoCausas/Remove'}
        isEdit={false}
        onClose={this.handleCloseEdit}
        validarAlteracao={false}
      />
    );
  }

  handleConfirmarExclusao(item) {
    http
      .post('RiscoCausaControle/Remove', {
        id: item.id,
      })
      .then(() => {
        this.handleCloseEdit(true);
        this.props.refreshCount && this.props.refreshCount(true);
      });
  }

  handleDesvincularConfirmClick(item) {
    ContentManager.addContent(
      <Confirm
        message={this.props.intl.formatMessage(
          { id: 'desvincularControleCausaConsequencia' },
          { pontodecontrole: this.props.resources.pontodecontrole }
        )}
        handleConfirm={this.handleConfirmarExclusao.bind(this, item)}
      />
    );
  }

  handleCloseEdit(saved) {
    if (saved) {
      const refreshTemp = Math.random();
      this.props.refreshCount && this.props.refreshCount(refreshTemp);
      this.setState({ saved: refreshTemp });
    }
  }

  handleOpenAddCausa() {
    ContentManager.addContent(
      <CausasRiscoEdit
        url="/RiscoCausas"
        parameters={{ riscoId: this.props.riscoId }}
        afterSave={this.props.refreshCount}
        valueField="descricao"
        saved={this.state.saved}
        {...this.props}
      />
    );
  }

  renderButtonAddCausaRiscoIA() {
    return [
      <Button
        id={'botaoMapearCausasRisco'}
        key={1}
        className="ml-2"
        onClick={() => this.handleOpenAddCausa()}
        type="primary"
      >
        <LucideIcon color="#fff" icon="Plus" size={15} />
        <span className="ml-2">
          {capitalizeFirstLetter(this.props.resources.pontosproblematicos)}
        </span>
      </Button>,
    ];
  }

  handleAssistenteVirtualClick() {
    const { user, intl, resources } = this.props;

    try {
      http
        .post('/RiscoCausas/ObterPromptMapearCausas', {
          idRisco: this.props.riscoId,
        })
        .then((response) => {
          const prompt = response.data?.prompt;

          const msgConsultoraVirtual = intl
            .formatMessage({ id: 'labelRiscos' })
            .replace('{riscos}', capitalizeFirstLetter(resources.riscos));

          ContentManager.addContent(
            <AssistenteVirtual
              user={user}
              prompt={prompt}
              title={msgConsultoraVirtual}
              actionsToolBar={this.renderButtonAddCausaRiscoIA()}
              questionBold={intl.formatMessage({ id: 'vamosComecar' })}
              interactionType={TIPO_INTERACAO_SOPHIE.SUGERIR_CAUSA_RISCO}
            />
          );
        });
    } catch (err) {
      errorHandler(err);
    }
  }

  render() {
    const { configuracao, disabled, intl, resources } = this.props;

    const actionsToolBar = [
      <>
        <Button
          id={'botaoMapearCausasRisco'}
          key={1}
          className="ml-2"
          onClick={this.handleAssistenteVirtualClick}
          type="primary"
        >
          <SophieIcon color="#fff" size={15} />
          <span className="ml-2">
            {intl.formatMessage(
              { id: 'mapearCausas' },
              {
                pontosproblematicos: capitalizeFirstLetter(
                  resources.pontosproblematicos
                ),
              }
            )}
          </span>
        </Button>
        <UncontrolledTooltip
          placement="right"
          target={'botaoMapearCausasRisco'}
        >
          {intl.formatMessage(
            {
              id: 'labelSophieToolTipMapearCausasRisco',
            },
            {
              riscos: resources.riscos,
            }
          )}
        </UncontrolledTooltip>
      </>,
    ];

    return (
      <List
        editComponent={CausasRiscoEdit}
        url="/RiscoCausas"
        showDelete={true}
        showExportItem={false}
        showExport={false}
        hierarchy={true}
        valueField="descricao"
        saved={this.state.saved}
        showNew={!disabled}
        showMenu={!disabled}
        parameters={{ riscoId: this.props.riscoId }}
        afterSave={this.props.refreshCount}
        afterDelete={this.props.refreshCount}
        onDeleting={this.handleDesvincularClick}
        actionsToolBarEnd={actionsToolBar}
        hideInsertDropDown={true}
        {...this.props}
      >
        <ListColumn
          headerText={intl.formatMessage({ id: 'descricao' })}
          tree={true}
          valueField="descricao"
          required
        />
        {!disabled &&
          configuracao &&
          configuracao.associarControleCausaConsequencia && (
            <ListColumn
              valueField="addControle"
              valueFunction={(item, callback) =>
                this.renderDescricao(item, callback, configuracao)
              }
              required={
                configuracao.associacaoControleCausaConsequenciaObrigatoria
              }
            />
          )}
      </List>
    );
  }
}

function mapStateToProps(state) {
  return {
    resources: state.user.termos,
    moduloInteligenciaArtificial: state.user.moduloInteligenciaArtificial,
    user: state.user,
  };
}
export default injectIntl(connect(mapStateToProps)(CausasRiscoList));
